
export const SKU_LIST_G64000K: string[] = [
"G64000K-Bl-XS",
"G64000K-Bl-S",
"G64000K-Bl-M",
"G64000K-Bl-L",
"G64000K-Bl-XL",
"G64000K-MilGr-XS",
"G64000K-MilGr-S",
"G64000K-MilGr-M",
"G64000K-MilGr-L",
"G64000K-MilGr-XL",
"G64000K-Or-XS",
"G64000K-Or-S",
"G64000K-Or-M",
"G64000K-Or-L",
"G64000K-Or-XL",
"G64000K-DaHe-XS",
"G64000K-DaHe-S",
"G64000K-DaHe-M",
"G64000K-DaHe-L",
"G64000K-DaHe-XL",
"G64000K-LiBl-XS",
"G64000K-LiBl-S",
"G64000K-LiBl-M",
"G64000K-LiBl-L",
"G64000K-LiBl-XL",
"G64000K-Ma-XS",
"G64000K-Ma-S",
"G64000K-Ma-M",
"G64000K-Ma-L",
"G64000K-Ma-XL",
"G64000K-IrGr-XS",
"G64000K-IrGr-S",
"G64000K-IrGr-M",
"G64000K-IrGr-L",
"G64000K-IrGr-XL",
"G64000K-Pu-XS",
"G64000K-Pu-S",
"G64000K-Pu-M",
"G64000K-Pu-L",
"G64000K-Pu-XL",
"G64000K-Cha-XS",
"G64000K-Cha-S",
"G64000K-Cha-M",
"G64000K-Cha-L",
"G64000K-Cha-XL",
"G64000K-Wh-XS",
"G64000K-Wh-S",
"G64000K-Wh-M",
"G64000K-Wh-L",
"G64000K-Wh-XL",
"G64000K-Na-XS",
"G64000K-Na-S",
"G64000K-Na-M",
"G64000K-Na-L",
"G64000K-Na-XL",
"G64000K-Re-XS",
"G64000K-Re-S",
"G64000K-Re-M",
"G64000K-Re-L",
"G64000K-Re-XL",
"G64000K-Ro-XS",
"G64000K-Ro-S",
"G64000K-Ro-M",
"G64000K-Ro-L",
"G64000K-Ro-XL",
"G64000K-SpGr-XS",
"G64000K-SpGr-S",
"G64000K-SpGr-M",
"G64000K-SpGr-L",
"G64000K-SpGr-XL",
"G64000K-LiPi-XS",
"G64000K-LiPi-S",
"G64000K-LiPi-M",
"G64000K-LiPi-L",
"G64000K-LiPi-XL",
"G64000K-Da-XS",
"G64000K-Da-S",
"G64000K-Da-M",
"G64000K-Da-L",
"G64000K-Da-XL",
"G64000K-GrHe-XS",
"G64000K-GrHe-S",
"G64000K-GrHe-M",
"G64000K-GrHe-L",
"G64000K-GrHe-XL",
"G64000K-Sap-XS",
"G64000K-Sap-S",
"G64000K-Sap-M",
"G64000K-Sap-L",
"G64000K-Sap-XL"
];